import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Container = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 6H11V11H9V6ZM13 11V6H15V11H13ZM17 11H19V6H17V11ZM23 11H21V6H23V11ZM25 11H25.7654H27V6H25V11ZM7 6H5L5 11H6.23449H7V6ZM4.2396 12.8504C3.51216 12.5511 3 11.8354 3 11V6C3 4.89543 3.89543 4 5 4H27C28.1046 4 29 4.89543 29 6V11C29 11.8354 28.4878 12.5512 27.7603 12.8504C27.7692 12.9715 27.7671 13.0954 27.7532 13.2209L26.1976 27.2209C26.0851 28.2337 25.229 29 24.2099 29H7.79004C6.77095 29 5.91482 28.2337 5.80228 27.2209L4.24672 13.2209C4.23278 13.0953 4.23072 12.9715 4.2396 12.8504ZM6.23449 13L6.59384 16.2341C8.83434 15.6138 11.2582 16.0269 13.1798 17.3995L13.5943 17.6956C15.4789 19.0417 17.9268 19.3142 20.0612 18.4155L25.4141 16.1616L25.7654 13H6.23449ZM7.79004 27L6.81856 18.2566C8.56552 17.6657 10.5018 17.9445 12.0174 19.027L12.4318 19.3231C14.8814 21.0727 18.063 21.4269 20.8374 20.2588L25.1612 18.4382L24.2099 27L7.79004 27Z"
          fill="currentColor"
        />
      </svg>
    )}
  ></Icon>
)

export default Container
